/**
 * Creates a Promise with strongly typed error
 * @param executor - Promise executor function
 * @returns Promise with typed error
 */
export function makePromise(executor) {
    return new Promise(executor);
}
/**
 * Creates a Deferred promise
 * @returns Promise with resolve/reject methods exposed
 */
export const defer = () => {
    let resolve, reject;
    const p = makePromise((resolve_, reject_) => {
        resolve = resolve_;
        reject = reject_;
    });
    return Object.assign(p, { resolve, reject });
};
//# sourceMappingURL=Deferred.js.map